export type ClarkUserPreferenceId = "suggestNextSteps";

export const CLARK_USER_PREFERENCES_SECTION_FEATURE_FLAG_ID =
  "ui.builder-preferences.enabled";

const CLARK_USER_PREFERENCE_IDS = [
  "suggestNextSteps",
] as const satisfies readonly ClarkUserPreferenceId[];

export const CLARK_USER_PREFERENCE_DEFINITIONS = {
  suggestNextSteps: {
    description: "Clark suggests follow-ups after each build.",
    // String, not the surface `Flag` enum, so `core/` stays free of
    // `src/app/` and `src/dashboard/` imports. Each surface casts to its own
    // `Flag` type when wiring `useFeatureFlag`.
    featureFlagId: "ai.suggest-whats-next",
    title: "Suggest next steps",
  },
} as const satisfies Record<
  ClarkUserPreferenceId,
  {
    description: string;
    featureFlagId: string;
    title: string;
  }
>;

export type ClarkUserPreferenceVisibility = Record<
  ClarkUserPreferenceId,
  boolean
>;

export const getVisibleClarkUserPreferenceIds = (
  visibility: ClarkUserPreferenceVisibility,
): ClarkUserPreferenceId[] =>
  CLARK_USER_PREFERENCE_IDS.filter((id) => visibility[id]);
